import { render, staticRenderFns } from "./MakeAppointmentList.vue?vue&type=template&id=68a5e845&scoped=true&"
import script from "./MakeAppointmentList.vue?vue&type=script&lang=js&"
export * from "./MakeAppointmentList.vue?vue&type=script&lang=js&"
import style0 from "./MakeAppointmentList.vue?vue&type=style&index=0&id=68a5e845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5e845",
  null
  
)

export default component.exports